import axios from "axios";
import dayjs from "dayjs";
import store from "../reducers";
import { ALERT } from "../constants";
import { ActionType } from "../types/alert";

const ROOT_API = process.env.REACT_APP_API_ENDPOINT;

axios.interceptors.response.use(
  (response) => {
    if (
      (response.data &&
        response.data.responsecode === ALERT.invalidSessionCode &&
        response.data.response === "ERROR") ||
      (response.data &&
        response.data.message === ALERT.invalidJWTMsg &&
        response.data.code === 6)
    ) {
      store.dispatch({
        type: ActionType.OPEN_ALERT,
        payload: ALERT.invalidSessionMsg,
      });
    }

    return response;
  },
  (error) => Promise.reject(error)
);

const removeEmpty = (obj: any) => {
  Object.keys(obj).forEach(
    (k) => !obj[k] && obj[k] !== undefined && delete obj[k]
  );

  return obj;
};

/* ----------------------- */
/* Fixtures and Picks
/* ----------------------- */

export const getFixtures = (competition: string, date: string) =>
  axios({
    url: `${ROOT_API}/flashpicks/smartpicks/fixtures?competition=${competition}&date=${date}`,
    method: "get",
    headers: {
      "Content-Type": "application/json",
    },
  });

export const getConfig = (location: string) =>
  axios({
    url: `${ROOT_API}/flashpicks/config?location=${location}&version=20240805`,
    method: "get",
    headers: {
      "Content-Type": "application/json",
    },
  });

export const getSmartPicksByType = (
  type: string,
  market: string,
  basedOn: string,
  competitions: string,
  order: string,
  date: string,
  bookmaker: string,
  location?: string,
  fixtures?: string,
) =>
  axios({
    url: `${ROOT_API}/flashpicks/smartpicks/${type}?`,
    method: "get",
    headers: {
      "Content-Type": "application/json",
    },
    params: removeEmpty({
      market,
      competitions,
      basedOn,
      order,
      date,
      bookmaker,
      location,
      fixtures,
      tzOffset: dayjs().utcOffset(),
    }),
  });

export const getPlayerDetails = (
  playerId: string,
  teamId: string,
  eventId: string,
  marketType: string,
  basedOn: string
) =>
  axios({
    url: `${ROOT_API}/flashpicks/smartpicks/players/${playerId}/details?`,
    method: "get",
    headers: {
      "Content-Type": "application/json",
    },
    params: {
      teamId,
      eventId,
      marketType,
      basedOn,
    }
  });